import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M13.463 4.644a7.5 7.5 0 0 1 4.335 2.598c1.121 1.367 1.803 3.094 1.49 4.66a.5.5 0 1 0 .98.196c.395-1.97-.47-3.995-1.697-5.49a8.5 8.5 0 1 0-.56 11.403.5.5 0 1 0-.708-.707 7.5 7.5 0 1 1-3.84-12.66z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M11.5 7a.5.5 0 0 1 1 0v4.434a.5.5 0 0 0 .243.429l2.014 1.208a.5.5 0 0 1-.514.858l-2.015-1.209a1.5 1.5 0 0 1-.728-1.286z"
  })]
}), 'Clock');
//# sourceMappingURL=index.js.map